'use client';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Subscription } from 'types/collections';

import { DailyAvailability, DaySelectionPanel } from '@components/DaySelectionPanel';
import { Modal } from '@components/Modal';
import { Text } from '@components/TextGroups';

interface AvailabilityModalProps {
  isOpen: boolean;
  onClose: () => void;
  schoolName: string | undefined;
  currentSubscription: Subscription | undefined;
  selectedDays: DailyAvailability;
  onToggleDay: (day: keyof DailyAvailability) => void;
  onSaveAvailability: () => void;
  onUnsubscribe?: () => void;
}

/**
 * Modal component for managing teacher availability and school notifications
 */
export const AvailabilityModal: React.FC<AvailabilityModalProps> = ({
  isOpen,
  onClose,
  schoolName,
  selectedDays,
  onToggleDay,
  onSaveAvailability,
}) => {
  const { t } = useTranslation('common');

  const handleSaveAndClose = () => {
    onSaveAvailability();
    onClose();
  };

  const availabilityModalButtons = [
    {
      label: t('saveNotifications'),
      onClick: handleSaveAndClose,
      variant: 'primary' as const,
    },
  ];

  return (
    <Modal
      title={t('menu.teacherNotifications')}
      buttons={availabilityModalButtons}
      isOpen={isOpen}
      onClose={onClose}>
      <Text>
        {t('modals.notificationDescription', {
          schoolName: schoolName,
        })}
      </Text>
      <DaySelectionPanel selectedDays={selectedDays} onToggleDay={onToggleDay} />
    </Modal>
  );
};
